import {
  Component,
  ComponentRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {DynamicComponentService} from '../../services/dynamic-component/dynamic-component.service';
import {GlobalEventService} from '../../services/global-event/global-event.service';
import {ExampleHelpPopupComponent} from './example-help-popup.component';

@Component({
  selector: 'app-example-help-btn',
  template: `
    <aside #container
           class="page-help-box">

      <a class="page-help-btn" (click)="onClick($event)">
        <i class="ic ic-help"></i>
        <span class="txt">도움말</span>
      </a>
    </aside>
  `,
})
export class ExampleHelpBtnComponent {
  @ViewChild('container', { read: ViewContainerRef }) container?: ViewContainerRef;
  private componentRef: ComponentRef<ExampleHelpPopupComponent> | null = null;

  constructor(
    private dynamicSvc: DynamicComponentService,
    private globalEventSvc: GlobalEventService,
  ) {

  }

  onClick($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (!this.container) {
      throw new Error('ExampleHelpBtnComponent::onClick() container is null');
    }

    if (this.componentRef) {
      this.closePopup();
    }
    else {
      this.componentRef = this.dynamicSvc.createComponent(ExampleHelpPopupComponent, this.container);
      this.componentRef.instance.close.subscribe(() => {
        this.closePopup();
      });
    }
  }

  private closePopup() {
    this.componentRef?.destroy();
    this.componentRef = null;
  }
}
